import * as React from 'react';

export default function DogFriendly({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 16.6667 15.837'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.08333 7.50004C3.23393 7.50004 4.16667 6.5673 4.16667 5.41671C4.16667 4.26611 3.23393 3.33337 2.08333 3.33337C0.93274 3.33337 0 4.26611 0 5.41671C0 6.5673 0.93274 7.50004 2.08333 7.50004Z"
        fill="currentColor"
      />
      <path
        d="M5.83333 4.16667C6.98393 4.16667 7.91667 3.23393 7.91667 2.08333C7.91667 0.93274 6.98393 0 5.83333 0C4.68274 0 3.75 0.93274 3.75 2.08333C3.75 3.23393 4.68274 4.16667 5.83333 4.16667Z"
        fill="currentColor"
      />
      <path
        d="M10.8333 4.16667C11.9839 4.16667 12.9167 3.23393 12.9167 2.08333C12.9167 0.93274 11.9839 0 10.8333 0C9.68274 0 8.75 0.93274 8.75 2.08333C8.75 3.23393 9.68274 4.16667 10.8333 4.16667Z"
        fill="currentColor"
      />
      <path
        d="M14.5833 7.50004C15.7339 7.50004 16.6667 6.5673 16.6667 5.41671C16.6667 4.26611 15.7339 3.33337 14.5833 3.33337C13.4327 3.33337 12.5 4.26611 12.5 5.41671C12.5 6.5673 13.4327 7.50004 14.5833 7.50004Z"
        fill="currentColor"
      />
      <path
        d="M12.7832 9.88333C12.0582 9.03333 11.4499 8.30833 10.7165 7.45833C10.3332 7.00833 9.84154 6.55833 9.25821 6.35833C9.16654 6.325 9.07488 6.3 8.98321 6.28333C8.77488 6.25 8.54988 6.25 8.33321 6.25C8.11654 6.25 7.89154 6.25 7.67488 6.29167C7.58321 6.30833 7.49154 6.33333 7.39988 6.36667C6.81654 6.56667 6.33321 7.01667 5.94154 7.46667C5.21654 8.31667 4.60821 9.04167 3.87488 9.89167C2.78321 10.9833 1.44154 12.1917 1.69154 13.8833C1.93321 14.7333 2.54154 15.575 3.63321 15.8167C4.24154 15.9417 6.18321 15.45 8.24988 15.45H8.39988C10.4665 15.45 12.4082 15.9333 13.0165 15.8167C14.1082 15.575 14.7165 14.725 14.9582 13.8833C15.2165 12.1833 13.8749 10.975 12.7832 9.88333Z"
        fill="currentColor"
      />
    </svg>
  );
}
